module.exports = {
    "id": null,
    "racedayId": null,
    "location": null,
    "name": "",
    "description": "",
    "largeImageUrl": "",
    "mediumImageUrl": "",
    "websiteUrl": "",
    "startTime": "",
    "endTime": "",
    "active": false,
    "dynamicLink1": { id: null, name: "", url: "", imageUrl: "" },
    "dynamicLink2": { id: null, name: "", url: "", imageUrl: "" }
};
